import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const ClusterForm = ({ clusterId, initialData, onSuccess }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const [clusterName, setClusterName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // ✅ Fill form if initialData is provided (edit mode)
  useEffect(() => {
    if (initialData && initialData.cluster) {
      setClusterName(initialData.cluster);
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!clusterName.trim()) {
      setError('Cluster name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      let url = '';
      let method = 'POST';
      let body = {};

      if (clusterId) {
        // ✅ Edit mode
        url = `${baseUrl}/updateClusterById/${clusterId}`;
        body = { cluster: clusterName };
      } else {
        // ✅ Create mode
        url = `${baseUrl}/createCluster`;
        body = { cluster: clusterName };
      }

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.status) {
        alert(clusterId ? 'Cluster updated successfully' : 'Cluster created successfully');
        if (onSuccess) onSuccess();
        navigate('/cluster');
      } else {
        setError(data.message || `Failed to ${clusterId ? 'update' : 'create'} CLUSTER`);
      }
    } catch (err) {
      setError('Error connecting to server');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    navigate('/cluster');
  };

  

  return (
    <form className="general-info-form" onSubmit={handleSubmit}>
      <h2 className="section-title">{clusterId ? 'Edit Cluster' : 'Add Cluster'}</h2>
      <div className="form-grid">
        <div className="form-floating">
          <input
            type="text"
            className="form-control"
            id="clusterName"
            placeholder=" "
            autoComplete="off"
            value={clusterName}
            onChange={(e) => setClusterName(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="clusterName">Cluster Name</label>
        </div>
      </div>
      <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
      <button
        type="submit"
        className="btn btn-primary"
       
        disabled={loading}
      >
        {loading ? 'Saving...' : 'Save'}
      </button>
      <button
      type="button"
      
      className="btn btn-secondary"
      onClick={handleCloseModal}
      disabled={loading}
    >
      Cancel
    </button>
      </div>
    </form>
  );
};

export default ClusterForm;
